import { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface LoginDialogContextType {
  isOpen: boolean;
  openLoginDialog: () => void;
  closeLoginDialog: () => void;
}

const LoginDialogContext = createContext<LoginDialogContextType | undefined>(undefined);

export const LoginDialogProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openLoginDialog = useCallback(() => setIsOpen(true), []);
  const closeLoginDialog = useCallback(() => setIsOpen(false), []);

  return (
    <LoginDialogContext.Provider value={{ isOpen, openLoginDialog, closeLoginDialog }}>
      {children}
    </LoginDialogContext.Provider>
  );
};

export const useLoginDialog = () => {
  const context = useContext(LoginDialogContext);
  if (!context) throw new Error("useLoginDialog must be used within LoginDialogProvider");
  return context;
};
